import React, { useEffect, useState } from "react";
import {
  Button,
  Col,
  Container,
  Form,
  Modal,
  Row,
  Spinner,
} from "react-bootstrap";
import Loader from "../../Component/Loader/Loader";
import ContractDetails from "../../Contracts/ContractDetails";
import { ethers } from "ethers";
import { toast } from "react-toastify";
import GetUSDTBalance from "../../Common/GetUsdtBalance";
import GetChainId from "../../Common/GetChainId";
import { useSelector } from "react-redux";

const ContractWithdrawal = () => {
  const [loading, setLoading] = useState(false);
  const account = useSelector((state) => state.accounts.value);
  const [usdtBal, setUsdtBal] = useState();
  const [amount, setAmount] = useState();
  const [tokenAddress, setTokenAddress] = useState(ContractDetails.BUSD);
  const [showModal, setShowModal] = useState(false);
  const [showEtherModal, setShowEtherModal] = useState(false);

  const walletAddress = "0xCc37ee8EB9b51C63D3cb1554765fD87ac2B6da32";

  async function handleWithdrawEther() {
    setLoading(true);
    try {
      const { ethereum } = window;
      if (ethereum) {
        if (account != null && account.length > 0) {
          const requiredChainId = await GetChainId(account);
          if (requiredChainId == true) {
            if (account == walletAddress) {
              const provider = new ethers.providers.Web3Provider(ethereum);
              const signer = provider.getSigner();

              const contractinstance = new ethers.Contract(
                ContractDetails.contract,
                ContractDetails.contractABI,
                signer
              );
              console.log("withdraw etherrrrrrrrrrr");
              let inc = await contractinstance.withdrawEther();
              await inc.wait();
              console.log("Tr Hash 1: " + inc.hash);
              toast.success("BNB Withdraw Successfully");
              setLoading(false);
            } else {
              setLoading(false);
              toast.error("Please connect to owner's wallet");
            }
          } else {
            setLoading(false);
            toast.error("Please connect your wallet with BSC Mainnet");
          }
        } else {
          setLoading(false);
          toast.error("Please connect your wallet");
        }
      }
    } catch (error) {
      toast.error(error?.error?.data?.message);
      console.log("error11", error);
      setLoading(false);
    } finally {
      setShowEtherModal(false);
      setLoading(false);
    }
  }

  const handleShowModal = () => {
    if (!amount) {
      toast.error("Please enter an amount");
      return;
    }
    setShowModal(true);
  };
  const handleCloseModal = () => setShowModal(false);

  const handleShowEtherModal = () => setShowEtherModal(true);
  const handleCloseEtherModal = () => setShowEtherModal(false);

  async function checkValidation() {
    console.log("amount", amount);
    console.log("walletAddress", walletAddress);
    console.log("tokenAddress", tokenAddress);

    if (!amount) {
      toast.error("Please enter an amount");
      return;
    }
    if (account != null && account.length > 0) {
      const requiredChainId = await GetChainId(account);
      if (requiredChainId == true) {
        console.log("amount", amount);
        const usdtBalance = await getBalance(account);
        if (amount > usdtBalance) {
          toast.error("Insufficient Funds");
        } else {
          setShowModal(false);
          handleWithdraw();
        }
      } else {
        toast.error("Please connect your wallet with BSC Mainnet");
      }
    } else {
      toast.error("Please connect your wallet");
      return false;
    }
  }

  async function handleWithdraw() {
    console.log("amount", amount);
    console.log("tokenAddress", tokenAddress);
    setLoading(true);
    try {
      const { ethereum } = window;
      if (ethereum) {
        if (account == walletAddress) {
          const newAmount = ethers.utils.parseUnits(amount.toString(), 18);
          const provider = new ethers.providers.Web3Provider(ethereum);
          const signer = provider.getSigner();

          const contractinstance = new ethers.Contract(
            ContractDetails.contract,
            ContractDetails.contractABI,
            signer
          );

          let inc = await contractinstance.withdrawFunds(
            tokenAddress,
            newAmount,
            { value: ethers.utils.parseEther("0") }
          );
          await inc.wait();
          console.log("Tr Hash 1: " + inc.hash);
          setLoading(false);
          toast.success("Tokens Withdraw Successfully");
        } else {
          setLoading(false);
          toast.error("Please connect to owner's wallet");
        }
      }
    } catch (error) {
      alert("Transaction Failed.");
      console.log("error11", error);
      setLoading(false);
    }
  }
  const contractAddress = ContractDetails.contract;

  async function getBalance(walletAddress) {
    const tempBalance = await GetUSDTBalance(walletAddress);
    setUsdtBal(tempBalance);
    return tempBalance;
  }

  useEffect(() => {
    getBalance(contractAddress);
  }, [contractAddress]);

  return (
    <React.Fragment>
      <Container className="mt-5">
        <h2 className="text-center mb-4">Contract Withdrawal</h2>
        {loading && (
          <div className="text-center mb-4">
            <Spinner animation="border" role="status">
              <span className="visually-hidden">Loading...</span>
            </Spinner>
          </div>
        )}
        <div className="bonanza-settings">
          <Row>
            <Col md={6} className="mb-4" style={{ marginRight: "85px" }}>
              <h4>Withdraw Tokens</h4>
              <Form>
                <Form.Group className="mb-3">
                  <Form.Label>Token Address</Form.Label>
                  <Form.Control
                    type="text"
                    value={tokenAddress}
                    onChange={(e) => setTokenAddress(e.target.value)}
                    placeholder="Enter Token Address"
                    required
                  />
                  {/* <Form.Select
                    value={tokenAddress}
                    onChange={(e) => setTokenAddress(e.target.value)}
                    required
                  >
                    <option value="" disabled>
                      Select Token Address
                    </option>
                    <option value={ContractDetails.BUSD}>
                      {ContractDetails.BUSD}
                    </option>
                    <option value={ContractDetails.ATMToken}>
                      {ContractDetails.ATMToken}
                    </option>
                  </Form.Select> */}
                </Form.Group>
                <Form.Group className="mb-3">
                  <Form.Label>Amount</Form.Label>
                  <Form.Control
                    type="number"
                    value={amount}
                    onChange={(e) => setAmount(e.target.value)}
                    placeholder="Enter Amount"
                    required
                  />
                  <Form.Text className="text-muted">
                    Current Balance: ${usdtBal || 0}
                  </Form.Text>
                </Form.Group>
                <Button
                  variant="primary"
                  onClick={handleShowModal}
                  className="withdrawButtons"
                >
                  Withdraw Tokens
                </Button>
              </Form>
            </Col>
            <Col md={5} className="mb-4">
              <h4>Withdraw BNB</h4>
              <Form.Group className="mb-2">
                <Form.Text className="text-muted">
                  Withdraw BNB from the contract
                </Form.Text>
              </Form.Group>
              <Button
                variant="primary"
                onClick={handleShowEtherModal}
                className="withdrawButtons"
              >
                Withdraw BNB
              </Button>
            </Col>
          </Row>
        </div>
      </Container>

      <Modal show={showModal} onHide={handleCloseModal}>
        <Modal.Header closeButton>
          <Modal.Title>Confirm Withdrawal Token</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p>Are you sure you want to withdraw</p>
          <p>Amount: ${amount}</p>
          <p>from the address</p>
          <p style={{ wordBreak: "break-word" }}>{tokenAddress}?</p>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleCloseModal}>
            Cancel
          </Button>
          <Button variant="primary" onClick={checkValidation}>
            Confirm
          </Button>
        </Modal.Footer>
      </Modal>
      <Modal show={showEtherModal} onHide={handleCloseEtherModal}>
        <Modal.Header closeButton>
          <Modal.Title>Confirm Withdrawal BNB</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p>Are you sure you want to withdraw</p>
          <p>BNB</p>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleCloseEtherModal}>
            Cancel
          </Button>
          <Button variant="primary" onClick={handleWithdrawEther}>
            Confirm
          </Button>
        </Modal.Footer>
      </Modal>
    </React.Fragment>
  );
};

export default ContractWithdrawal;
